/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { Fragment, type ReactNode } from 'react';

/** Простая разметка статей: «## », «- », «1. », **жирный**, «> » примечание */
function inline(s: string): ReactNode {
  const parts = s.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => (p.startsWith('**') && p.endsWith('**') ? <strong key={i}>{p.slice(2, -2)}</strong> : <Fragment key={i}>{p}</Fragment>));
}

export function Markdown({ text }: { text: string }) {
  const blocks = text.trim().split(/\n\s*\n/);
  return (
    <div className="space-y-3 text-[15px] leading-relaxed text-slate-700">
      {blocks.map((b, i) => {
        const lines = b.split('\n');
        if (lines[0].startsWith('## ')) {
          const rest = lines.slice(1).join('\n');
          return <Fragment key={i}><h2 className="pt-2 text-lg font-semibold text-slate-900">{lines[0].slice(3)}</h2>{rest && <Markdown text={rest} />}</Fragment>;
        }
        if (lines.every((l) => /^- /.test(l))) return <ul key={i} className="list-disc space-y-1 pl-6">{lines.map((l, j) => <li key={j}>{inline(l.slice(2))}</li>)}</ul>;
        if (lines.every((l) => /^\d+\. /.test(l))) return <ol key={i} className="list-decimal space-y-1 pl-6">{lines.map((l, j) => <li key={j}>{inline(l.replace(/^\d+\. /, ''))}</li>)}</ol>;
        if (lines[0].startsWith('> ')) return <div key={i} className="rounded-md border-l-4 border-brand-500 bg-brand-50 px-3 py-2 text-sm">{inline(lines.map((l) => l.replace(/^> /, '')).join(' '))}</div>;
        return <p key={i}>{inline(lines.join(' '))}</p>;
      })}
    </div>
  );
}
